/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnRightUpIcon24Regular = forwardRef('ArrowDUturnRightUpIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M23.238 9.152a.875.875 0 1 1-1.276 1.197l-4.087-4.36V13a7.875 7.875 0 0 1-15.75 0V7a.875.875 0 1 1 1.75 0v6a6.125 6.125 0 0 0 12.25 0V5.936l-4.137 4.413a.875.875 0 1 1-1.276-1.197l4.53-4.833c.939-1 2.527-1 3.466 0l4.53 4.833Z" })));
});
